import { defineMessages } from 'react-intl';

export const ILeafletMarkerSchema = (intl) => ({
  title: intl.formatMessage(messages.marker),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'latitude', 'longitude', 'icon'],
    },
  ],

  properties: {
    title: {
      title: intl.formatMessage(messages.title),
      type: 'string',
    },
    latitude: {
      title: intl.formatMessage(messages.latitude),
      type: 'number',
    },
    longitude: {
      title: intl.formatMessage(messages.longitude),
      type: 'number',
    },
    icon: {
      title: intl.formatMessage(messages.icon),
      type: 'number',
      widget: 'icon_select',
    },
  },
  required: [],
});

export const ILeafletMapSchema = (intl) => ({
  title: intl.formatMessage(messages.map),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
	'west', 'north','east', 'south',
	'latitude', 'longitude', 'zoom'],
    },
    {
      id: 'content',
      title: intl.formatMessage(messages.content),
      fields: ['markers'],
    },
    {
      id: 'style',
      title: intl.formatMessage(messages.style),
      fields: ['height','align', 'geojson', 'icons'],
    },
  ],

  properties: {
    north: {
      title: intl.formatMessage(messages.north),
      type: 'number',
      maximum: 90,
      minimum: -90,
    },
    west: {
      title: intl.formatMessage(messages.west),
      type: 'number',
      maximum: 90,
      minimum: -90,
    },
    east: {
      title: intl.formatMessage(messages.east),
      type: 'number',
      maximum: 90,
      minimum: -90,
    },
    south: {
      title: intl.formatMessage(messages.south),
      type: 'number',
      maximum: 90,
      minimum: -90,
    },
    latitude: {
      title: intl.formatMessage(messages.latitude),
      type: 'number',
      initialValue: 42,
      maximum: 90,
      minimum: -90,
    },
    longitude: {
      title: intl.formatMessage(messages.longitude),
      type: 'number',
      initialValue: -71,
      maximum: 180,
      minimum: -180,
    },
    zoom: {
      title: intl.formatMessage(messages.zoom),
      type: 'number',
      initialValue: 8,
      maximum: 18,
      minimum: 0,
    },
    height: {
      title: intl.formatMessage(messages.height),
      initialValue: '60vh',
    },
    align: {
      title: intl.formatMessage(messages.align),
      widget: 'align',
    },
    markers: {
      title: intl.formatMessage(messages.markers),
      schema: ILeafletMarkerSchema(intl),
      widget: 'object_list',
    },
    geojson: {
      title: intl.formatMessage(messages.geojson),
      widget: 'object_browser',
      mode: 'multiple',
      allowExternals: false,
    },
    icons: {
      title: intl.formatMessage(messages.icons),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
    },
  },
  required: [],
});

const messages = defineMessages({
  map: {
    id: 'Map',
    defaultMessage: 'Map',
  },
  west: {
    id: 'West',
    defaultMessage: 'West edge',
  },
  north: {
    id: 'North',
    defaultMessage: 'North edge',
  },
  east: {
    id: 'East',
    defaultMessage: 'East edge',
  },
  south: {
    id: 'South',
    defaultMessage: 'South edge',
  },
  latitude: {
    id: 'Latitude',
    defaultMessage: 'Latitude',
  },
  longitude: {
    id: 'Longitude',
    defaultMessage: 'Longitude',
  },
  zoom: {
    id: 'Zoom',
    defaultMessage: 'Zoom',
  },
  height: {
    id: 'Height',
    defaultMessage: 'Height',
  },
  align: {
    id: 'Align',
    defaultMessage: 'Align',
  },
  icon: {
    id: 'Icon',
    defaultMessage: 'Icon',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  marker: {
    id: 'Marker',
    defaultMessage: 'Marker',
  },
  markers: {
    id: 'Markers',
    defaultMessage: 'Markers',
  },
  content: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  style: {
    id: 'Style',
    defaultMessage: 'Style',
  },
  geojson: {
    id: 'GeoJSON',
    defaultMessage: 'GeoJSON folder',
  },
  icons: {
    id: 'Icons',
    defaultMessage: 'Icon folder',
  },
});
